enum CCBlockEvaluationTernaryRequirement
{
    RequirementsNotMet = 0,
    RequirementsMet = 1,
    NotRequired = 2
}

export default CCBlockEvaluationTernaryRequirement;
